import React from 'react'

const BookingContacts = () => {
  return (
    <>
      <h1 className='contact-title'>CONTACT ME</h1>
      <div className='booking-container'>
        <div className='agent-container'>
          <h3>
            <strong>Manager</strong> | Hot Tramp Management
          </h3>
          <p>Sarah@hottrampmanagement.com</p>
        </div>

        <div className='agent-container'>
          <h3>
            <strong>Label</strong> | Birthday Cake
          </h3>
          <p>bucky@birthdaycakemedia.com</p>
          <p>bee@birthdaycakemedia.com</p>
        </div>
      </div>
    </>
  )
}

export default BookingContacts
